const SDK_VERSION = '7.106.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
